module.exports = __webpack_public_path__ + "media/images/homes/GoMobilewithTablesidePOSordering-55b8e918390ab95a70afbd0aa68e06bb.png";